import { useEffect, useState } from "react";
import { Bell, Check } from "lucide-react";
import api from "../lib/api";
import { Loading } from "../components/Layout";
import { Button } from "../components/ui/button";

export default function Notifications() {
  const [data, setData] = useState(null);

  const load = () => api.get("/notifications").then((r) => setData(r.data));
  useEffect(() => { load(); }, []);

  const markAll = async () => {
    await api.post("/notifications/read-all");
    load();
  };

  if (data === null) return <Loading />;

  return (
    <div className="max-w-2xl mx-auto px-4 sm:px-6 py-12 animate-fade-up">
      <div className="flex items-center justify-between mb-8">
        <h1 className="font-display text-4xl">Notifications</h1>
        {data.unread > 0 && (
          <Button data-testid="mark-all-read" variant="outline" onClick={markAll} className="border-white/10 hover:bg-white/5">
            <Check size={15} className="mr-2" /> Mark all read
          </Button>
        )}
      </div>
      {data.items.length === 0 ? (
        <div className="text-center py-24 text-muted-foreground">
          <Bell size={40} strokeWidth={1.25} className="mx-auto mb-4 opacity-50" />
          <p>No notifications yet.</p>
        </div>
      ) : (
        <div className="space-y-2" data-testid="notifications-list">
          {data.items.map((n) => (
            <div key={n.id} className={`rounded-lg border p-4 ${n.read ? "border-white/5 bg-card/30" : "border-primary/30 bg-primary/5"}`}>
              <div className="flex items-center justify-between">
                <p className="font-medium">{n.title}</p>
                {!n.read && <span className="h-2 w-2 rounded-full bg-primary" />}
              </div>
              <p className="text-sm text-muted-foreground mt-1">{n.body}</p>
              <p className="text-xs text-muted-foreground/60 mt-2">{new Date(n.created_at).toLocaleString()}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
